import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { CommsTemplateComponent } from './comms-template.component';
import { CommsMaintenanceComponent } from './comms-maintenance.component';
import { CommsEventComponent } from './comms-event.component';
import { CommsHistoryComponent } from './comms-history.component';
import { NgxJsonViewerModule } from '../../modules/json-viewer/ngx-json-viewer.module';
import { CommsAttachmentsComponent } from './comms-attachments/comms-attachments.component';

const routes: Routes = [
  {
    path: '',
    component: CommsMaintenanceComponent,
    data: { title: 'Email/SMS Template Designer' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CommsMaintenanceRoutingModule {}

@NgModule({
  imports: [
    CommsMaintenanceRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    NgxJsonViewerModule,
  ],
  declarations: [
    CommsMaintenanceComponent,
    CommsTemplateComponent,
    CommsHistoryComponent,
    CommsEventComponent,
    CommsAttachmentsComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CommsMaintenanceModule {}
